import queryString from "query-string";

import { INTEGRATION_CREDENTIAL } from "constants/actionTypes";

import { serializeIntegrationBusinessCreate } from "lib/serializers/integrationBusinesses";
import { serializeIntegrationCredential } from "lib/serializers/integrationCredentials";

import {
  offlineActionCreator,
  offlineSubActionCreator,
  urlCheckAndAddIdAndAction,
} from "./lib";

const urlCreator = ({ changesSince, id, action } = {}) =>
  queryString.stringifyUrl({
    url: urlCheckAndAddIdAndAction("/v2/integration-credentials/", id, action),
    query: {
      changesSince,
    },
  });

export const IntegrationCredentialAction = offlineActionCreator(
  INTEGRATION_CREDENTIAL,
  serializeIntegrationCredential,
  urlCreator,
  false,
);

IntegrationCredentialAction.activate = (integrationCredentialId, tenantId) => ({
  type: INTEGRATION_CREDENTIAL.ACTIVATE.REQUEST,
  id: integrationCredentialId,
  tenantId,
});

IntegrationCredentialAction.synchronize = (
  integrationCredentialId,
  ignoredOptions,
) =>
  IntegrationCredentialAction.action(
    INTEGRATION_CREDENTIAL.SYNCHRONIZE,
    offlineSubActionCreator(INTEGRATION_CREDENTIAL.SYNCHRONIZE, urlCreator),
    { id: integrationCredentialId, action: "sync" },
  );

const pushLedgerAccountUrlCreator = ({
  changesSince,
  id,
  action,
  ledgerAccountIds,
} = {}) =>
  queryString.stringifyUrl({
    url: urlCheckAndAddIdAndAction("/v2/integration-credentials/", id, action),
    query: {
      changesSince,
      ledger_account_ids: ledgerAccountIds,
    },
  });

IntegrationCredentialAction.pushLedgerAccount = (
  integrationCredentialId,
  ledgerAccountIds,
) => {
  return IntegrationCredentialAction.action(
    INTEGRATION_CREDENTIAL.PUSH_LEDGER_ACCOUNTS,
    offlineSubActionCreator(
      INTEGRATION_CREDENTIAL.PUSH_LEDGER_ACCOUNTS,
      pushLedgerAccountUrlCreator,
    ),
    {
      id: integrationCredentialId,
      action: "push-ledger-accounts",
      ledgerAccountIds,
    },
  );
};

IntegrationCredentialAction.syncDocuments = (
  integrationCredentialId,
  ignoredOptions,
) =>
  IntegrationCredentialAction.action(
    INTEGRATION_CREDENTIAL.SYNC_DOCUMENTS,
    offlineSubActionCreator(INTEGRATION_CREDENTIAL.SYNC_DOCUMENTS, urlCreator),
    { id: integrationCredentialId, action: "sync-documents" },
  );

IntegrationCredentialAction.createBusiness = (
  integrationCredentialId,
  deserializedPayload,
) => {
  const payload = serializeIntegrationBusinessCreate(deserializedPayload);
  return IntegrationCredentialAction.action(
    INTEGRATION_CREDENTIAL.CREATE_BUSINESS,
    offlineSubActionCreator(
      INTEGRATION_CREDENTIAL.CREATE_BUSINESS,
      urlCreator,
      "POST",
    ),
    { id: integrationCredentialId, action: "create-business", ...payload },
  );
};
